if (!window.__progress_bar_js_injected__) {
    window.__progress_bar_js_injected__ = true;
    document.addEventListener('alpine:init', () => {
      Alpine.data('progressBar', (opts) => ({
        // props from liquid
        goal1: Number(opts.goal1 || 0),
        goal2Base: Number(opts.goal2 || 0),          // Base currency
        discount: Number(opts.discount || 0),
        cartTotal: Number(opts.initialTotal || 0),
        coupon: String(opts.coupon || ''),
        shopCurrency: String(opts.shopCurrency || 'USD'),

        // state
        goal2: 0,
        percent: 0,
        almost: '0',

        // helper: convert currency
        convertCurrency(amount, from, to) {
          const num = Number(amount) || 0;
          if (!from || !to || from === to) return num;

          // 1) If Currency.js available
          if (window?.Currency?.convert) {
            try {
              const cents = Math.round(num * 100);
              const convertedCents = Currency.convert(cents, from, to); // return cents
              return convertedCents / 100;
            } catch (e) { /* fallback */ }
          }

          // 2) Fallback rate Shopify
          const active = window?.Shopify?.currency?.active;
          const base   = window?.Shopify?.currency?.shopCurrency || this.shopCurrency;
          const rate   = window?.Shopify?.currency?.rate; // biasanya base→active

          if (rate && base && active) {
            if (from === base && to === active) {
              return num * Number(rate);           // base → active
            }
            if (from === active && to === base) {
              return num / Number(rate);           // active → base
            }
          }

          // 3) Last fallback: without rate ⇒ reset value
          return num;
        },

        get activeCurrency() {
          return window?.Shopify?.currency?.active || 'USD';
        },

        init() {
          this.goal2 = this.goal2Base;
          this.recompute();

          // Listen update cart
          const onCartUpdated = (e) => {
            const cart = e?.detail?.cart;
            if (!cart) return;
            this.cartTotal = cart.total_price / 100;
            this.recompute();
          };
          document.addEventListener('cart:updated', onCartUpdated);
          window.addEventListener('cart:updated', onCartUpdated);

          // Sync from /cart.js
          if (window?.Shopify && typeof fetch === 'function') {
            fetch('/cart.js')
              .then(r => r.json())
              .then(cart => {
                this.cartTotal = cart.total_price / 100;
                this.recompute();
              })
              .catch(() => {});
          }

          // Listen event custom goal2
          window.addEventListener('currency:change', () => {
            this.goal2 = this.goal2Base;
            this.recompute();
          });
        },

        recompute() {
          const g2 = this.goal2 > 0 ? this.goal2 : 1;
          const pct = (this.cartTotal / g2) * 100;
          this.percent = Math.max(0, Math.min(100, pct));

          const remain = Math.max(g2 - this.cartTotal, 0);

          const formatted = this.activeCurrency === 'EUR'
            ? remain.toFixed(2).replace('.', ',')
            : remain.toFixed(2);

          this.almost = formatted;

          // store global
          Alpine.store('progress').percent = this.percent;
          Alpine.store('progress').cartTotal = this.cartTotal;
          Alpine.store('progress').discount = this.discount;
          Alpine.store('progress').coupon = this.coupon;
        },

        // >>> Getters UI (barWidth & barText)
        get barWidth() {
          return this.percent === 0 ? '3%' : `${this.percent}%`;
        },

        get barText() {
          const active = this.activeCurrency;
          
          const currencyMap = {
            // === Default 7 ===
            AUD: { code: 'AUD', symbol: '$',  locale: 'en-AU' },
            CAD: { code: 'CAD', symbol: '$',  locale: 'en-CA' },
            EUR: { code: 'EUR', symbol: '€',   locale: (window?.Shopify?.country === 'DE' ? 'de-DE' : 'fr-FR') },
            NZD: { code: 'NZD', symbol: '$', locale: 'en-NZ' },
            GBP: { code: 'GBP', symbol: '£',   locale: 'en-GB' },
            USD: { code: 'USD', symbol: '$',   locale: 'en-US' },

            // === Europe group ===
            BGN: { code: 'BGN', symbol: 'лв',   locale: 'bg-BG' }, // Bulgaria
            HRK: { code: 'HRK', symbol: '€',    locale: 'hr-HR' }, // Croatia (EUR sejak 2023)
            CZK: { code: 'CZK', symbol: 'Kč',   locale: 'cs-CZ' }, // Czech Republic
            DKK: { code: 'DKK', symbol: 'kr',   locale: 'da-DK' }, // Denmark
            EEK: { code: 'EUR', symbol: '€',    locale: 'et-EE' }, // Estonia (EUR)
            FIM: { code: 'EUR', symbol: '€',    locale: 'fi-FI' }, // Finland (EUR)
            GRC: { code: 'EUR', symbol: '€',    locale: 'el-GR' }, // Greece (EUR)
            HUF: { code: 'HUF', symbol: 'Ft',   locale: 'hu-HU' }, // Hungary
            ISK: { code: 'ISK', symbol: 'kr',   locale: 'is-IS' }, // Iceland
            IRL: { code: 'EUR', symbol: '€',    locale: 'en-IE' }, // Ireland (EUR)
            ITL: { code: 'EUR', symbol: '€',    locale: 'it-IT' }, // Italy (EUR)
            LVA: { code: 'EUR', symbol: '€',    locale: 'lv-LV' }, // Latvia (EUR)
            LUX: { code: 'EUR', symbol: '€',    locale: 'fr-LU' }, // Luxembourg (EUR)
            NLD: { code: 'EUR', symbol: '€',    locale: 'nl-NL' }, // Netherlands (EUR)
            POL: { code: 'PLN', symbol: 'zł',   locale: 'pl-PL' }, // Poland
            PRT: { code: 'EUR', symbol: '€',    locale: 'pt-PT' }, // Portugal (EUR)
            RON: { code: 'RON', symbol: 'lei',  locale: 'ro-RO' }, // Romania
            SRB: { code: 'RSD', symbol: 'дин',  locale: 'sr-RS' }, // Serbia
            SVK: { code: 'EUR', symbol: '€',    locale: 'sk-SK' }, // Slovakia (EUR)
            SVN: { code: 'EUR', symbol: '€',    locale: 'sl-SI' }, // Slovenia (EUR)
            ESP: { code: 'EUR', symbol: '€',    locale: 'es-ES' }, // Spain (EUR)
            SWE: { code: 'SEK', symbol: 'kr',   locale: 'sv-SE' }, // Sweden
            CHE: { code: 'CHF', symbol: 'CHF',  locale: 'de-CH' }, // Switzerland

            // === Asia-Pacific & Americas ===
            HKG: { code: 'HKD', symbol: 'HK$',  locale: 'zh-HK' }, // Hong Kong SAR China
            JPY: { code: 'JPY', symbol: '¥',    locale: 'ja-JP' }, // Japan
            MEX: { code: 'MXN', symbol: '$',    locale: 'es-MX' }, // Mexico
            NOR: { code: 'NOK', symbol: 'kr',   locale: 'nb-NO' }, // Norway
            SGD: { code: 'SGD', symbol: 'S$',   locale: 'en-SG' }, // Singapore
            KRW: { code: 'KRW', symbol: '₩',    locale: 'ko-KR' }, // South Korea
            TWD: { code: 'TWD', symbol: 'NT$',  locale: 'zh-TW' }, // Taiwan
          };

          const conf = currencyMap[active] || currencyMap.USD;
          
          // Using symbol
          const formattedAmount = `${conf.symbol}${this.almost}`;

           // Save to global store
          Alpine.store('progress').almost = formattedAmount;

          return this.percent === 100
            ? `You’ve unlocked ${this.discount}% OFF!`
            : `Add just ${formattedAmount} more to unlock ${this.discount}% OFF!`;
        },

        get endIconClasses() {
          return this.percent === 100 ? 'bg-discount' : '';
        },
        get showBlueDot() {
          return this.percent < 100;
        },
        get blueDotPulse() {
          return this.percent >= 50 && this.percent < 100;
        },
      }));
    });
  }